"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wolfie = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var wolfie = function wolfie(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'wolfie-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M9.54838 7.30995C10.5903 6.97007 10.68 6.02309 10.9829 5.21615C11.23 4.55379 11.3138 4.51443 11.8697 4.9338C12.2866 5.24794 12.4087 5.50077 12.3638 5.99886C12.3315 6.35237 12.3175 6.82624 12.3175 7.1964C12.7366 5.9209 13.0653 5.99811 13.0653 5.99811C13.2396 5.98145 13.4741 6.34405 13.4741 6.34405C13.6587 6.61504 13.5123 7.10102 13.4315 7.27362C13.4315 7.27362 12.8322 8.91247 12.7109 9.85491C12.7109 9.85491 12.5763 10.4325 12.5373 10.7254C12.4204 11.6028 12.3697 11.8102 12.3498 12.6936C12.3396 13.1092 12.2851 13.5558 12.5219 14.4695C12.6043 14.7972 13.0579 16.3066 12.669 18C14.3154 17.4002 15.7259 16.2621 16.6851 14.7597C17.6444 13.2572 18.0998 11.4729 17.9817 9.67903C17.8636 7.88519 17.1785 6.1804 16.0311 4.82493C14.8837 3.46947 13.3369 2.53779 11.627 2.17213C9.91703 1.80647 8.13782 2.02692 6.56097 2.79983C4.98411 3.57274 3.69626 4.85564 2.89401 6.45268C2.09175 8.04972 1.81918 9.87316 2.1179 11.6446C2.41662 13.4161 3.27022 15.0383 4.54838 16.2635C4.61088 16.1363 4.67044 16.0069 4.72559 15.8729C4.92706 15.3846 5.24029 14.938 5.54176 14.5005C5.93073 13.9365 6.35794 13.4006 6.7697 12.851C6.76309 12.8419 6.75573 12.8253 6.74397 12.8185C5.81162 12.3196 5.75353 12.2 6.58073 11.5316C7.40794 10.8632 8.01088 10.1146 8.31603 9.04343C8.51088 8.16609 8.84838 7.53704 9.54838 7.31222',
    fill: '#4B5563'
  }));
};

exports.wolfie = wolfie;